export { default } from "./ClaimHistory";
